import { render } from "./CkeditorModule.vue?vue&type=template&id=54529b57&scoped=true"
import script from "./CkeditorModule.vue?vue&type=script&lang=ts"
export * from "./CkeditorModule.vue?vue&type=script&lang=ts"

import "./CkeditorModule.vue?vue&type=style&index=0&id=54529b57&lang=css"
import "./CkeditorModule.vue?vue&type=style&index=1&id=54529b57&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-54529b57"

export default script